import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IRREGULAR_PERIODS, ROLL_MODAL_ROLL_CONVENTION_OPTIONS } from 'src/app/product-capture/create-product/event-schedules/event-schedules.const';
import { DropDownOption } from 'src/app/product-capture/model/interfaces/drop-down-option.interface';
import { IrregularPeriodModeTypes } from '../roll-days-modal.component';

@Component({
  selector: 'app-roll-days-modal-row',
  templateUrl: './roll-days-modal-row.component.html',
  styleUrls: ['./roll-days-modal-row.component.scss']
})
export class RollDaysModalRowComponent {

  @Input()
  label: string;

  @Input()
  type: IrregularPeriodModeTypes;

  @Input()
  form: FormGroup;

  IrregularPeriodModeTypes = IrregularPeriodModeTypes;

  irregularPeriods: DropDownOption[] = IRREGULAR_PERIODS;

  rollConventions: DropDownOption[] = ROLL_MODAL_ROLL_CONVENTION_OPTIONS;

}
